import React, { useEffect, useState } from "react";
import { Table, Modal, Input, Button, Upload, message } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import { useNavigate } from "react-router-dom";
const { TextArea } = Input;

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [updatedName, setUpdatedName] = useState("");
  const [updatedDescription, setUpdatedDescription] = useState("");
  const [updatedImage, setUpdatedImage] = useState(null);
  const [deletedImage, setDeletedImage] = useState(null);

  // Fetch categories from backend
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${base_url}/api/categories/getAllCategories`);
        setCategories(response.data.categoriesWithImages);
        console.log(response.data)
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);
  
  
  const navigate = useNavigate();

    const adminToken = localStorage.getItem("adminToken");
console.log("Admin Token:", adminToken);

 useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    if (!adminToken) {
      navigate("/");
    }
  }, [navigate]);

  // Handle Edit Button Click
  const handleEdit = (category) => {
    setSelectedCategory(category);
    setUpdatedName(category.name);
    setUpdatedDescription(category.description);
    setUpdatedImage(category.images?.[0] || null);
    setDeletedImage(null);
    setIsModalOpen(true);
  };

  // Handle Save Changes
const handleSaveChanges = async () => {
    if (!updatedName || !updatedDescription) {
        message.error("Name and Description are required.");
        return;
    }

    try {
        const formData = new FormData();
        formData.append("id", selectedCategory.category_id);  // Ensure you are sending the correct category ID
        formData.append("name", updatedName);
        formData.append("description", updatedDescription);
        formData.append("existingImage", selectedCategory.images?.[0] || null); // Send current image

        if (updatedImage && typeof updatedImage !== "string") {
            formData.append("image", updatedImage);  // Add the new image if it's selected
        }

        console.log("FormData entries:", ...formData);  // Log FormData to verify its contents

        await axios.put(`${base_url}/api/categories/update`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        message.success("Category updated successfully!");
        setIsModalOpen(false);
    } catch (error) {
        console.error("Error updating category:", error);
        message.error("Failed to update category.");
    }
};




  // Handle Image Upload
  const handleImageUpload = ({ file }) => {
    setUpdatedImage(file);
  };

  // Handle Image Removal
  const handleRemoveImage = () => {
    if (typeof updatedImage === "string") {
      setDeletedImage(updatedImage); // Set the existing image as deleted
    }
    setUpdatedImage(null); // Clear the image preview
  };

  // Handle Delete Category
  const handleDeleteCategory = async (categoryId) => {
    try {
      await axios.delete(`${base_url}/api/categories/delete/${categoryId}`);
      message.success("Category deleted successfully!");
      setCategories(categories.filter((category) => category.category_id !== categoryId)); // Remove deleted category from state
    } catch (error) {
      console.error("Error deleting category:", error);
      message.error("Failed to delete category.");
    }
  };

  // Table columns
  const columns = [
    {
      title: "Image",
      dataIndex: "images",
      key: "images",
      render: (images) =>
        images && images.length > 0 ? (
          <img
            src={`${base_url}${images[0]}`}
            alt="category"
            style={{
              width: "50px",
              height: "50px",
              objectFit: "cover",
              borderRadius: "4px",
            }}
          />
        ) : (
          "No Image"
        ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div style={{ textAlign: "right" }}>
          <BiEdit
            className="action-icon"
            style={{ cursor: "pointer", marginRight: "10px", fontSize: "18px" }}
            onClick={() => handleEdit(record)}
          />
          <AiFillDelete
            className="action-icon text-danger"
            style={{ cursor: "pointer", fontSize: "18px" }}
            onClick={() => handleDeleteCategory(record.category_id)} // Trigger delete on click
          />
        </div>
      ),
    },
  ];

  // Table data source
  const dataSource = categories.map((category, index) => ({
    key: index + 1,
    name: category.name,
    description: category.description,
    images: category.images,
    category_id: category.category_id,
  }));

  return (
    <div>
      <h3 className="mb-4 title">Product Categories</h3>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={{ pageSize: 5 }}
        rowKey="category_id"
      />

      {/* Edit Modal */}
      <Modal
        title="Edit Category"
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleSaveChanges}>
            Save Changes
          </Button>,
        ]}
      >
        <div>
          <label>Name:</label>
          <Input
            value={updatedName}
            onChange={(e) => setUpdatedName(e.target.value)}
            placeholder="Enter category name"
            style={{ marginBottom: "10px" }}
          />

          <label>Description:</label>
          <TextArea
            value={updatedDescription}
            onChange={(e) => setUpdatedDescription(e.target.value)}
            placeholder="Enter category description"
            rows={4}
            style={{ marginBottom: "10px" }}
          />

          <label>Image:</label>
          {updatedImage ? (
            <div style={{ marginBottom: "10px" }}>
              <img
                src={
                  typeof updatedImage === "string"
                    ? `${base_url}${updatedImage}`
                    : URL.createObjectURL(updatedImage)
                }
                alt="category"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  borderRadius: "4px",
                }}
              />
              <Button type="link" danger onClick={handleRemoveImage}>
                Remove Image
              </Button>
            </div>
          ) : (
            <Upload
              accept="image/*"
              beforeUpload={() => false}
              onChange={handleImageUpload}
            >
              <Button type="link">Upload Image</Button>
            </Upload>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default CategoryList;
